import { OrganizationManagerFragment } from "gql/graphql";
import { PersonName } from "@/modules/common/entities/person/person-name";
import { Hidable, Value } from "@/shared/value";

/** Руководитель подразделения — сам по себе защищённая сущность, отсюда `PersonName`. */
export function OrganizationManager({
  data,
}: {
  data?: Hidable<OrganizationManagerFragment>;
}) {
  return (
    <Value data={data}>
      {(organization) => <PersonName data={organization.manager} />}
    </Value>
  );
}
